import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { getWebAppUrl } from '../utils/config';
import { DEFAULT_TRIAL_PERIOD_DAYS } from '../config/config';

const Hero: React.FC = () => {
  const handleStartTrial = () => {
    window.location.href = `${getWebAppUrl()}/create-account`;
  };

  return (
    <section className="hero-section-modern">
      <Container>
        <Row className="align-items-center" style={{ minHeight: '90vh', paddingTop: '80px', paddingBottom: '60px' }}>
          <Col lg={6} className="mb-5 mb-lg-0">
            {/* Minimal LTD Badge */}
            <div className="mb-4">
              <span className="ltd-badge">
                🔥 Limited: $399 Lifetime Deal • Only 10 Left
              </span>
            </div>

            <h1 className="hero-title mb-4">
              CRM + Custom Revenue Systems for Home Service Businesses
            </h1>

            <p className="hero-subtitle mb-5">
              We do more than CRM. We build custom integrations, lead funnels, and automated sales pipelines that turn more leads into booked jobs and repeat revenue.
            </p>

            <div className="d-flex flex-wrap gap-3 mb-5">
              <Button
                className="btn-modern-primary"
                onClick={handleStartTrial}
              >
                Claim Lifetime Deal
              </Button>

              {DEFAULT_TRIAL_PERIOD_DAYS > 0 && (
                <Button
                  className="btn-modern-secondary"
                  onClick={handleStartTrial}
                >
                  Start {DEFAULT_TRIAL_PERIOD_DAYS}-Day Free Trial
                </Button>
              )}
            </div>

            <div className="mb-4">
              <h5 className="mb-2">Need revenue-focused workflows? We build them.</h5>
              <p className="text-muted mb-2">
                We design and implement custom systems around your process so leads never go cold and sales opportunities are followed up automatically.
              </p>
              <ul className="list-unstyled text-muted mb-0">
                <li>Custom lead funnels from first contact to booked appointment</li>
                <li>Sales automation sequences for follow-up, reactivation, and upsells</li>
                <li>Custom integrations between your CRM, forms, ads, and communication tools</li>
                <li>Revenue pipelines that automate quoting, invoicing, payments, and retention</li>
              </ul>
            </div>

            <p className="hero-caption">
              {DEFAULT_TRIAL_PERIOD_DAYS > 0
                ? `${DEFAULT_TRIAL_PERIOD_DAYS}-day trial • No credit card • 30-day money-back guarantee`
                : '30-day money-back guarantee'}
            </p>
          </Col>

          <Col lg={6}>
            <div className="hero-visual">
              <div className="visual-card">
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Happy Customers</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50K+</div>
                  <div className="stat-label">Appointments</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">99.9%</div>
                  <div className="stat-label">Uptime</div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
